export default __webpack_public_path__ + "static/media/EcommerceServicesLebenswerkBusinessManagement3.062fdeee.png";